import { Fragment, ReactNode } from 'react';
import { Button, Spinner, SxStyleProp, Text } from 'theme-ui';
import { hidden } from 'utils/mixins';
import { FileInputChildrenType } from 'shared/FileInput';
import Icon, { IconTypes } from 'shared/Icon';

const uploadBtnStyle = (loading: boolean): SxStyleProp => ({
  bg: 'var(--x-accent-1-5)',
  justifyContent: 'center',
  flex: 1,
  py: 4,
  width: '100%',
  height: '44px',
  border: '0',
  div: {
    color: 'tertiary'
  },
  svg: {
    fill: 'var(--x-accent-1-5)',
    stroke: loading ? 'white' : 'none',
    transition: 'inherit'
  },
  cursor: loading ? 'default' : 'pointer'
});

export const UploadBtn = ({
  handleInputChange,
  handleClick,
  inputRef,
  accept,
  loading,
  className,
  children,
  onClickHandler
}: FileInputChildrenType & {
  loading: boolean;
  className?: string;
  children: ReactNode;
  onClickHandler?: () => void;
}) => (
  <Button
    data-test="upload"
    disabled={loading}
    as="label"
    variant="secondary"
    sx={uploadBtnStyle(loading)}
    type="button"
    className={className}
  >
    {loading ? (
      <Spinner size={24} color="primary" strokeWidth={3} />
    ) : (
      <Fragment>
        <Icon name="upload-gen" type={IconTypes.Tertiary} />
        <Text sx={{ ml: '10px', fontSize: 2 }}>{children}</Text>
        <input
          sx={hidden}
          type="file"
          ref={inputRef}
          onChange={handleInputChange}
          onClick={() => {
            handleClick();
            onClickHandler && onClickHandler();
          }}
          accept={accept}
          name="file"
          disabled={loading}
        />
      </Fragment>
    )}
  </Button>
);
